import BasicLayout from '../layouts/BasicLayout';

function Privacy() {
    return (
        <BasicLayout>
            <div>
                <h3>Privacy Policy</h3>
                {/* Sample full privacy policy */}
                <p>Effective Date: [Insert Date]</p>
                <p>Thank you for using our eBay React app. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our app.</p>
                <p>Information We Collect:</p>
                <ul>
                    <li>Personal Information: We may collect your name, email address, and other personal information you provide when you use our app.</li>
                    <li>Usage Information: We may collect information about how you use our app, including the pages you visit and the features you use.</li>
                    <li>Device Information: We may collect information about the device you use to access our app, including your IP address and browser type.</li>
                </ul>
                <p>How We Use Your Information:</p>
                <ul>
                    <li>To provide and improve our app: We use your information to provide and improve our app, including to deliver content and features you request.</li>
                    <li>To communicate with you: We use your information to communicate with you, including to respond to your inquiries and provide updates about our app.</li>
                    <li>To protect our app: We use your information to protect our app and our users, including to detect and prevent fraud and other security threats.</li>
                </ul>
                <p>Security:</p>
                <p>We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure.</p>
                <p>Children:</p>
                <p>Our app is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under the age of 13.</p>
                <p>Changes to This Privacy Policy:</p>
                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                <p>Contact Us:</p>
                <p>If you have any questions or concerns about this Privacy Policy, please contact us at [Insert Contact Information].</p>
            </div>
        </BasicLayout>
    );
}

export default Privacy;
